import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PhoneFilledIcon } from "@gemini/icons";
import { PhoneBlock } from "./ui";
import { PhoneLink } from "../Link/PhoneLink";
export const PhoneItem = ({ index, phoneNumber, testId }) => (_jsxs(PhoneBlock, { testId: `${testId}.PhoneNumber.${index}`, children: [_jsx(PhoneFilledIcon, { size: "sizing.16", marginHorizontal: "spacing.2" }), _jsx(PhoneLink, { title: phoneNumber })] }));
